// extracted by mini-css-extract-plugin
module.exports = {"header":"mgroups_header__XbMBB","table":"mgroups_table__2kHlz"};